"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SummerPromo;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _api = require("@whitbread-eos/api");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _react2 = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SummerPromo(_ref) {
  var {
    promotionBanner,
    showNotification
  } = _ref;
  var {
    language
  } = (0, _utils.useCustomLocale)();
  var [showMore, setShowMore] = (0, _react2.useState)(false);
  var {
    [_api.FT_PI_SUMMER_SALE_PROMO_BANNER]: isSummerPromoCodeEnabled
  } = (0, _utils.useFeatureToggle)();
  var bannerInfo = promotionBanner;
  var currentWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
  var [width, setWidth] = (0, _react2.useState)(currentWidth);
  var isMdWidth = width >= 768;
  var [hasCellCodes, setHasCellCode] = (0, _react2.useState)(true);
  (0, _react2.useEffect)(() => {
    var handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  (0, _react2.useEffect)(() => {
    var {
      search
    } = window.location;
    var searchParameters = new URLSearchParams(search);
    setHasCellCode(searchParameters.has('CELLCODES') || searchParameters.has('CORPID'));
  }, []);
  if (!hasCellCodes && bannerInfo !== null && bannerInfo !== void 0 && bannerInfo.enabled && isSummerPromoCodeEnabled && language === 'en') {
    var termsLink = (0, _jsxRuntime.jsx)("span", {
      style: _objectSpread({}, bannerTermsStyles),
      children: (0, _utils.renderSanitizedHtml)(bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.terms)
    });
    return (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({
      "data-testid": "SummerPromoContainer"
    }, bannerContainerStyles), {}, {
      children: [(0, _jsxRuntime.jsxs)(_react.Box, _objectSpread(_objectSpread({}, boxContainerStyles), {}, {
        children: [(0, _jsxRuntime.jsxs)(_react.Text, _objectSpread(_objectSpread({}, bannerTitleStyles), {}, {
          fontSize: "lg",
          fontWeight: "bold",
          children: [(0, _jsxRuntime.jsxs)(_react.Box, _objectSpread(_objectSpread({}, bannerTitleBoxStyles), {}, {
            children: [(0, _jsxRuntime.jsx)(_atoms.Icon, {
              src: (0, _utils.formatAssetsUrl)(bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.icon),
              style: _objectSpread({}, bannerIcon)
            }), bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.title]
          })), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, cheveronContainerStyles), {}, {
            "data-testid": "chevronIconContainer",
            children: showMore ? (0, _jsxRuntime.jsx)(_atoms.ChevronUp24, {
              color: "#FDB913",
              onClick: () => setShowMore(false),
              "data-testid": "chevronUpIcon"
            }) : (0, _jsxRuntime.jsx)(_atoms.ChevronDown24, {
              color: "#FDB913",
              onClick: () => setShowMore(true),
              "data-testid": "chevronDownIcon"
            })
          }))]
        })), (0, _jsxRuntime.jsxs)(_react.Text, {
          color: "white",
          fontSize: "sm",
          style: showMore || isMdWidth ? {
            display: 'block'
          } : hideTextStyles,
          children: [bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.description, " ", showNotification ? termsLink : null, !showNotification && !isMdWidth && (0, _jsxRuntime.jsx)(_react.Box, {
            "data-testid": "termsLink",
            children: termsLink
          })]
        })]
      })), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, notificationBoxStyles), {}, {
        children: showNotification ? (0, _jsxRuntime.jsx)(_atoms.Notification, {
          variant: "alert",
          status: "warning",
          title: promotionBanner === null || promotionBanner === void 0 ? void 0 : promotionBanner.srpNotificationTitle,
          description: promotionBanner === null || promotionBanner === void 0 ? void 0 : promotionBanner.srpNotificationText,
          svg: (0, _jsxRuntime.jsx)(_atoms.Alert, {}),
          isInnerHTML: true,
          wrapperStyles: wrapperStyles,
          style: notificationTextStyles
        }) : isMdWidth ? termsLink : null
      }))]
    }));
  }
  return null;
}
var bannerContainerStyles = {
  backgroundColor: '#511E62',
  display: 'grid',
  gridTemplateColumns: {
    base: '1fr',
    md: '1fr 1fr'
  },
  px: {
    base: '1rem',
    md: '1.5rem',
    xl: '66px'
  },
  py: {
    base: '0.75rem',
    md: '0.5rem'
  }
};
var bannerTitleBoxStyles = {
  display: 'flex',
  alignItems: 'center'
};
var bannerTitleStyles = {
  color: '#FDB913',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};
var bannerTermsStyles = {
  textDecoration: 'underline',
  pointer: 'cursor',
  color: 'white',
  fontSize: 'sm'
};
var bannerIcon = {
  display: 'inline',
  width: '16px',
  height: '16px',
  marginRight: '6px'
};
var hideTextStyles = {
  display: 'none'
};
var cheveronContainerStyles = {
  display: {
    sm: 'block',
    md: 'none'
  }
};
var boxContainerStyles = {};
var notificationBoxStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  color: 'white',
  width: {
    xs: 'full',
    md: 'auto'
  }
};
var wrapperStyles = {
  padding: {
    xs: '6px 8px',
    md: '6px 24px 6px 12px'
  },
  width: {
    xs: 'full',
    md: 'auto'
  },
  marginTop: {
    xs: '5px',
    md: '0'
  },
  alignItems: 'center'
};
var notificationTextStyles = {
  fontSize: '13px',
  lineHeight: '150%',
  fontWeight: '700'
};